import { Spin } from "antd";
import React, { ButtonHTMLAttributes } from "react";
import { BiArrowFromLeft } from "react-icons/bi";
import { Content } from './styles'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement>{
    loading?: boolean;
}
export function NextButton({ loading= false, ...rest } : Props){
    return(
        <Content  { ...rest} disabled={loading} loading={loading}>
            {
                loading
                ? <div className="loading"><Spin /></div>
                : <BiArrowFromLeft />
            }
                    
        </Content>
    )
}